import script from "./FichaEjercito.vue?vue&type=script&setup=true&lang=ts"
export * from "./FichaEjercito.vue?vue&type=script&setup=true&lang=ts"

import "./FichaEjercito.vue?vue&type=style&index=0&id=3f6f579c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f6f579c"]])

export default __exports__